export const crmMessageSchedule = {
  status: {
    scheduled: "schedules",
    processing: "processing",
    done: "done",
  },
};
